export const OPEN_CLOSE_SEARCH_SCREEN = "OPEN_CLOSE_SEARCH_SCREEN";
